module.exports = __webpack_public_path__ + "img/GoldenCustoms.0843a4e3.svg";